import { getArticlePath } from 'utils/urlUtils'
import { NotificationWithArticle, InformalFeedbackRequestNotification } from './types'
import qs from 'qs'
import { generatePath } from 'react-router-dom'
import { DESIGN_PATH, DOC_PATH } from 'paths'

interface articleOrLayerPathProps {
  notification: NotificationWithArticle
  right_rail?: string
  commentsFilter?: string
  todosFilter?: string
  id?: string | number
}

interface informalFeedbackRequestPathProps {
  notification: InformalFeedbackRequestNotification
  submit?: boolean
}

export const articleOrLayerPath = ({
  notification,
  right_rail,
  commentsFilter,
  todosFilter,
  id,
}: articleOrLayerPathProps) => {
  if (!notification.article) return ''

  const params = qs.stringify({ right_rail, commentsFilter, todosFilter, id, layer: notification.layer_id })
  return `${getArticlePath({ slug: notification.article.key })}?${params}`
}

export const informalFeedbackRequestPath = ({ notification, submit = false }: informalFeedbackRequestPathProps) => {
  const params = submit ? '?submitReview=true' : ''

  if (notification.article) {
    return `${generatePath(DOC_PATH, { slug: notification.article.key })}${params}`
  } else if (notification.design) {
    return `${generatePath(DESIGN_PATH, { key: notification.design.key })}${params}`
  }
}
